var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18C32.9909 26.2805 26.2805 32.9909 18 33ZM18 6C11.4081 6.00167 6.05169 11.3203 6.00336 17.912C5.95503 24.5037 11.2329 29.9003 17.824 29.9987C24.4152 30.097 29.8517 24.8602 30 18.27V20.9445V18C29.9926 11.3757 24.6243 6.00744 18 6ZM20.175 25.35L12.75 17.925L20.175 10.5L22.296 12.621L16.992 17.925L22.2945 23.229L20.1765 25.35H20.175Z",
    fill: "url(#paint0_linear_455_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_218",
    x1: 18,
    y1: 3.00002,
    x2: 18,
    y2: 41.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B388EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronLeft);
export default __webpack_public_path__ + "static/media/circle_chevron_left.f9e420df99017e32aae12f34a7f4bed5.svg";
export { ForwardRef as ReactComponent };